import React from "react";
import timeFunction from "../../functions/getTime";
import { Link } from "react-router-dom";

/**
 * Vertical news card — design/new card.png (bottom two) & design/News-all.png
 *   normal : 227px cover, black title, #4B4F55 excerpt, #919191 meta
 *   hover  : title turns #FF4713
 */
export default function VerticalCard(props) {
  const imageUrl =
    props.data && props.data.image && props.data.image[0]
      ? `${process.env.REACT_APP_API_URL}${props.data.image[0].url}`
      : "";

  const linkTo =
    props.page === "newsAndActivity/news"
      ? `/${props.lang}/${props.page}/${props.data.slug}`
      : `/${props.lang}/article/${props.data.slug}`;

  return (
    <Link
      to={linkTo}
      className="group flex flex-col h-full rounded-[12px] border-[1px] border-cardBorder bg-white overflow-hidden"
    >
      <div
        className="w-full h-[227px] bg-lightGray bg-cover bg-center shrink-0"
        style={
          imageUrl
            ? { backgroundImage: `url(${imageUrl})` }
            : { backgroundColor: "#D9D9D9" }
        }
      />

      <div className="flex flex-col flex-1 px-[20px] pt-[16px] pb-[18px]">
        <h2 className="text-lead font-normal text-black leading-tight line-clamp-3 text-left group-hover:text-brand transition-colors duration-200">
          {props.lang === "th"
            ? props.data.title.detail_TH
            : props.data.title.detail_EN}
        </h2>

        <p className="mt-[10px] text-body text-slateGray leading-snug line-clamp-1 text-left">
          {props.lang === "th"
            ? props.data?.description?.detail_TH
            : props.data?.description?.detail_EN}
        </p>

        <div className="mt-auto pt-[16px]">
          <p className="text-meta text-metaGray text-left">
            {timeFunction.getTime(props.data.publishedAt, props.lang)}
          </p>
          <p className="mt-[6px] text-meta text-metaGray text-right group-hover:text-brand transition-colors duration-200">
            {props.lang === "th" ? "อ่านเพิ่มเติม" : "Read More"}
          </p>
        </div>
      </div>
    </Link>
  );
}
